export default "__VITE_ASSET__C3L9j5aj__"